/* Giftbox Sverige – bildförstoring */
(() => {
  if (window.gbLightbox) return;
  window.gbLightbox = true;
  let items = [], i = 0, box = null, lastFocus = null;
  const render = () => {
    const img = box.querySelector('img'); img.src = items[i].src; img.alt = items[i].alt;
    const many = items.length > 1;
    box.querySelector('.gb-lb__prev').hidden = box.querySelector('.gb-lb__next').hidden = !many;
    box.querySelector('.gb-lb__count').textContent = many ? (i + 1) + ' / ' + items.length : '';
  };
  const close = () => { if (!box) return; box.remove(); box = null; document.documentElement.style.overflow = ''; lastFocus && lastFocus.focus(); };
  const step = (d) => { i = (i + d + items.length) % items.length; render(); };
  const open = (list, start) => {
    items = list; i = start; lastFocus = document.activeElement;
    box = document.createElement('div');
    box.className = 'gb-lb'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Förstorad bild');
    box.innerHTML = '<img alt=""><button type="button" class="gb-lb__close" aria-label="Stäng">×</button><button type="button" class="gb-lb__prev" aria-label="Föregående bild">‹</button><button type="button" class="gb-lb__next" aria-label="Nästa bild">›</button><span class="gb-lb__count"></span>';
    box.addEventListener('click', (e) => {
      if (e.target.closest('.gb-lb__prev')) step(-1);
      else if (e.target.closest('.gb-lb__next')) step(1);
      else if (e.target.tagName !== 'IMG') close();
    });
    let x0 = null;
    box.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40 && items.length > 1) step(dx < 0 ? 1 : -1); x0 = null; });
    document.body.appendChild(box); document.documentElement.style.overflow = 'hidden';
    render(); requestAnimationFrame(() => box.classList.add('is-open'));
    box.querySelector('.gb-lb__close').focus();
  };
  document.addEventListener('keydown', (e) => {
    if (!box) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft' && items.length > 1) step(-1);
    if (e.key === 'ArrowRight' && items.length > 1) step(1);
  });
  const toItem = (el) => ({ src: el.dataset.zoom, alt: el.dataset.zoomAlt || el.getAttribute('alt') || '' });
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-zoom-open]');
    if (!o) return;
    e.preventDefault();
    const g = o.dataset.zoomGroup;
    if (g) {
      const list = [...document.querySelectorAll('[data-zoom-item][data-zoom-group="' + g + '"]')];
      if (list.length) return open(list.map(toItem), Math.max(0, list.findIndex((x) => x.classList.contains('is-active'))));
    }
    open([toItem(o)], 0);
  });
})();
